import getAdditionalCustomerAddress from './getAdditionalCustomerAddress';

const getAdditionalCustomerAddressFormObject = (state, customerId) => {
  const address = getAdditionalCustomerAddress(state, customerId) ?? {};
  return {
    ...address,
    country: {
      label: address?.country?.name ?? '',
      value: address?.country?.id ?? -1,
      code: address?.country?.code ?? '',
    },
  };
};

export default getAdditionalCustomerAddressFormObject;
